import { render, staticRenderFns } from "./PromotionResult.vue?vue&type=template&id=6509d080&"
import script from "./PromotionResult.vue?vue&type=script&lang=js&"
export * from "./PromotionResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports